export default __webpack_public_path__ + "static/media/ebk-logo.ba8470f7.jpeg";